const commonValidation = {
  fromEmployeeAlias: {
    type: 'string',
    required: true,
  },
  toEmployeeAlias: {
    type: 'string',
    required: false,
  },
  plannedStart: {
    type: 'date',
    required: true,
  },
  comment: {
    type: 'string',
    required: false,
  },
  minPercent: {
    type: 'number',
    required: {
      value: true,
      when: {
        $toEmployeeAlias: {
          notEmpty: true,
        },
      },
    },
  },
  maxPercent: {
    type: 'number',
    required: {
      value: true,
      when: {
        $toEmployeeAlias: {
          notEmpty: true,
        },
      },
    },
  },
  isBench: {
    type: 'boolean',
    required: {
      value: true,
      when: {
        $toEmployeeAlias: {
          notEmpty: true,
        },
      },
    },
  },
  isPrivate: {
    type: 'boolean',
    required: {
      value: true,
      when: {
        $toEmployeeAlias: {
          notEmpty: true,
        },
      },
    },
  },
  slotId: {
    type: 'string',
    required: {
      value: true,
      when: {
        $toEmployeeAlias: {
          notEmpty: true,
        },
      },
    },
  },
};

export const replacementValidation = {
  ...commonValidation,
  plannedEnd: {
    type: 'date',
    required: false,
    minDate: {
      value: '$.plannedStart',
      message: 'Please choose date after "from" date',
    },
  },
};

export const backupValidation = {
  ...commonValidation,
  plannedEnd: {
    type: 'date',
    required: true,
    minDate: {
      value: '$.plannedStart',
      message: 'Please choose date after "from" date',
    },
  },
};
